module.exports = __webpack_public_path__ + "static/media/linkedin.f8fffc79.png";